import { motion } from "framer-motion";
import { MANIFESTO, COMPANY } from "@/data";

export default function Manifesto() {
  return (
    <section
      data-testid="about"
      id="about"
      className="bg-background text-foreground py-28 md:py-40"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="mb-20 border-t border-black/15 pt-6"
        >
          <span className="font-mono-accent text-xs uppercase tracking-[0.25em] text-primary">
            /01 — Who we are
          </span>
          <h2 className="font-display mt-6 text-4xl md:text-6xl tracking-tighter max-w-4xl leading-[0.95]">
            {COMPANY.name} is Mumbai&apos;s dedicated ready-mix supplier.
          </h2>
        </motion.div>

        <div className="space-y-0">
          {MANIFESTO.map((m, i) => (
            <motion.div
              key={m.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className="grid grid-cols-12 gap-6 border-t border-black/15 py-12 group"
            >
              <div className="col-span-12 md:col-span-3">
                <span className="font-display text-6xl md:text-7xl text-primary/90 group-hover:text-primary transition-colors">
                  {m.n}
                </span>
              </div>
              <div className="col-span-12 md:col-span-9 md:pl-8">
                <h3 className="font-display text-3xl md:text-4xl tracking-tight mb-4">
                  {m.title}
                </h3>
                <p className="text-base md:text-lg text-muted-foreground leading-relaxed max-w-2xl">
                  {m.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
